// extracted by mini-css-extract-plugin
export default {"typetext":"ea67f3499e83f2b0486b"};